(function () {
  'use strict';
  var queue = window.BAFPendingPortrait;
  if (!queue) return;
  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }
  function createCard(job) {
    var card = element('article', 'baf-pending-portrait');
    card.dataset.pendingPortrait = job.id;
    var image = element('img', 'baf-pending-portrait__image');
    image.alt = '';
    if (/^(https:)?\/\//.test(job.display.previewUrl || '')) image.src = job.display.previewUrl;
    else image.hidden = true;
    var content = element('div', 'baf-pending-portrait__content');
    content.appendChild(element('h3', '', job.display.title || 'Custom Dog Portrait'));
    content.appendChild(element('p', 'baf-pending-portrait__variant', job.display.variant));
    content.appendChild(element('p', 'baf-pending-portrait__price', job.display.price));
    var status = element('p', 'baf-pending-portrait__status');
    status.setAttribute('role', 'status');
    content.appendChild(status);
    var progress = element('progress', 'baf-pending-portrait__progress');
    progress.max = 100;
    progress.setAttribute('aria-label', 'Photo upload progress');
    content.appendChild(progress);
    content.appendChild(element('p', 'baf-pending-portrait__note', 'Your portrait will appear in your cart when the upload is complete.'));
    var actions = element('div', 'baf-pending-portrait__actions');
    ['Retry', 'Remove'].forEach(function (label) {
      var button = element('button', '', label);
      button.type = 'button';
      button.dataset.pendingAction = label.toLowerCase();
      button.addEventListener('click', function () {
        button.disabled = true;
        var action = label === 'Retry' ? queue.retry(job.id) : queue.cancel(job.id);
        Promise.resolve(action).catch(function (error) { status.textContent = error.message || 'Please try again.'; }).finally(function () { button.disabled = false; });
      });
      actions.appendChild(button);
    });
    content.appendChild(actions);
    card.appendChild(image);
    card.appendChild(content);
    return card;
  }
  function renderHost(parent, jobs) {
    var host = parent.querySelector(':scope > .baf-pending-portraits');
    parent.classList.toggle('baf-has-pending-portrait', jobs.length > 0);
    if (!jobs.length) { if (host) host.remove(); return; }
    if (!host) {
      host = element('section', 'baf-pending-portraits');
      host.setAttribute('aria-label', 'Portraits being added to your cart');
      parent.insertBefore(host, parent.firstChild);
    }
    Array.from(host.children).forEach(function (card) {
      if (!jobs.some(function (job) { return job.id === card.dataset.pendingPortrait; })) card.remove();
    });
    jobs.forEach(function (job) {
      var card = Array.from(host.children).find(function (node) { return node.dataset.pendingPortrait === job.id; });
      if (!card) { card = createCard(job); host.appendChild(card); }
      card.querySelector('.baf-pending-portrait__status').textContent = job.message || 'Uploading photo…';
      var progress = card.querySelector('progress');
      if (Number.isFinite(job.progress)) progress.value = Math.min(100, Math.max(0, job.progress));
      else progress.removeAttribute('value');
      progress.hidden = job.status === 'failed';
      card.querySelector('[data-pending-action="retry"]').hidden = job.status !== 'failed';
      card.querySelector('[data-pending-action="remove"]').hidden = !job.canCancel;
    });
  }
  function render() {
    var jobs = queue.list();
    document.querySelectorAll('.cart-drawer__content:not(.cart-drawer__content--empty) > .cart-drawer__items, .cart-drawer__content--empty, .cart-page__items').forEach(function (parent) { renderHost(parent, jobs); });
  }
  queue.subscribe(render);
  queue.ready().then(render).catch(function () {});
  document.addEventListener('cart:update', function () { window.requestAnimationFrame(render); });
  new MutationObserver(function (records) {
    if (records.some(function (record) {
      return Array.from(record.addedNodes).some(function (node) {
        return node.nodeType === 1 && (node.matches('.cart-drawer__content, .cart-page__items') || node.querySelector('.cart-drawer__content, .cart-page__items'));
      });
    })) render();
  }).observe(document.body, { childList: true, subtree: true });
})();
